export default __webpack_public_path__ + "static/media/threescreen.c2a37336.png";